/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './op-medication.reducer';

export const OpMedicationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const opMedicationEntity = useAppSelector(state => state.opMedication.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="opMedicationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.opMedication.detail.title">OpMedication</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.opMedication.id">Id</Translate>
            </span>
          </dt>
          <dd>{opMedicationEntity.id}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tinyMedicRestApp.opMedication.type">Type</Translate>
            </span>
          </dt>
          <dd>{opMedicationEntity.type}</dd>
          <dt>
            <span id="timeAdvised">
              <Translate contentKey="tinyMedicRestApp.opMedication.timeAdvised">Time Advised</Translate>
            </span>
          </dt>
          <dd>{opMedicationEntity.timeAdvised}</dd>
          <dt>
            <span id="timeAdministered">
              <Translate contentKey="tinyMedicRestApp.opMedication.timeAdministered">Time Administered</Translate>
            </span>
          </dt>
          <dd>{opMedicationEntity.timeAdministered}</dd>
          <dt>
            <span id="dose">
              <Translate contentKey="tinyMedicRestApp.opMedication.dose">Dose</Translate>
            </span>
          </dt>
          <dd>{opMedicationEntity.dose}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.opMedication.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{opMedicationEntity.notes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.opMedication.active">Active</Translate>
            </span>
          </dt>
          <dd>{opMedicationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.opMedication.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{opMedicationEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.opMedication.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{opMedicationEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.opMedication.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{opMedicationEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.opMedication.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{opMedicationEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.opMedication.surgery">Surgery</Translate>
          </dt>
          <dd>{opMedicationEntity.surgery ? opMedicationEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.opMedication.drug">Drug</Translate>
          </dt>
          <dd>{opMedicationEntity.drug ? opMedicationEntity.drug.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.opMedication.intraOPChart">Intra OP Chart</Translate>
          </dt>
          <dd>{opMedicationEntity.intraOPChart ? opMedicationEntity.intraOPChart.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.opMedication.postOPRecoveryRecord">Post OP Recovery Record</Translate>
          </dt>
          <dd>{opMedicationEntity.postOPRecoveryRecord ? opMedicationEntity.postOPRecoveryRecord.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.opMedication.preOpAnaesthesiaChart">Pre Op Anaesthesia Chart</Translate>
          </dt>
          <dd>{opMedicationEntity.preOpAnaesthesiaChart ? opMedicationEntity.preOpAnaesthesiaChart.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/op-medication" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/op-medication/${opMedicationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default OpMedicationDetail;
